'use strict';
import React, { PureComponent } from 'react';


class ModelosContablesRegistrosBuscador extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarInput = this.cambiarInput.bind(this);
    }

    cambiarInput(modelo, adicionarModelo) {
        this.props.cambiarInputBuscadorModelosActivo("");
        this.props.guardarQuitarModeloSeleccionado(this.props.seccionInput, modelo, adicionarModelo)
    }

    render() {
        const { modelo } = this.props;

        let descripcionModelo = modelo.Codigo + " - " + modelo.Descripcion

        return (
            <div className="ABMModelos__opcionBuscadorCuentasContables" onClick={() => this.cambiarInput(modelo.Codigo, true)}>
                {descripcionModelo}
            </div>
        );
    }
}

export default ModelosContablesRegistrosBuscador;